import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1751.02022,1806.92713 L1751.02022,1920 L168,1920 L168,1806.92713 L1751.02022,1806.92713 Z M1751.02022,1580.78138 L1751.02022,1693.85425 L168,1693.85425 L168,1580.78138 L1751.02022,1580.78138 Z M1013.78509,0 L1013.78509,1168.382 L1369.51235,812.541666 L1449.56794,892.59726 L957.248654,1384.80348 L464.929365,892.59726 L544.984959,812.541666 L900.712218,1168.382 L900.712218,0 L1013.78509,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPageDownLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPageDownLine, _Component);

  var _super = _createSuper(IconPageDownLine);

  function IconPageDownLine() {
    _classCallCheck(this, IconPageDownLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPageDownLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPageDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPageDownLine.displayName = "IconPageDownLine";
  return IconPageDownLine;
}(Component);

IconPageDownLine.glyphName = 'page-down';
IconPageDownLine.variant = 'Line';
IconPageDownLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPageDownLine;
export { IconPageDownLine };